import { render } from "./HelloWorld.vue?vue&type=template&id=5e5d05db&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=5e5d05db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e5d05db"

export default script